/* RiseLabs+ — interactive behaviour for the custom storefront sections.
   Vanilla JS, no dependencies. Loaded with defer from theme.liquid. */
(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- Age gate ---------------------------------------------------------- */
  function initAgeGate() {
    var gate = document.getElementById("vl-agegate");
    if (!gate) return;

    var KEY = "veridian-age-verified";
    var alreadyVerified;
    try {
      alreadyVerified = window.localStorage.getItem(KEY);
    } catch (e) {
      alreadyVerified = null;
    }

    if (alreadyVerified) {
      gate.parentNode && gate.parentNode.removeChild(gate);
      return;
    }

    gate.hidden = false;
    document.body.style.overflow = "hidden";

    var boxes = gate.querySelectorAll('input[type="checkbox"]');
    var confirm = gate.querySelector(".vl-agegate__confirm");

    function sync() {
      var all = true;
      boxes.forEach(function (b) {
        if (!b.checked) all = false;
      });
      confirm.disabled = !all;
    }
    boxes.forEach(function (b) {
      b.addEventListener("change", sync);
    });
    sync();

    confirm.addEventListener("click", function () {
      if (confirm.disabled) return;
      try {
        window.localStorage.setItem(KEY, "true");
      } catch (e) {}
      gate.style.opacity = "0";
      document.body.style.overflow = "";
      window.setTimeout(function () {
        gate.parentNode && gate.parentNode.removeChild(gate);
      }, 200);
    });
  }

  /* ---- Scroll reveal ----------------------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll(".vl-reveal");
    if (!els.length) return;
    if (reduceMotion || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("vl-in"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var delay = parseInt(el.getAttribute("data-vl-delay") || "0", 10);
            window.setTimeout(function () { el.classList.add("vl-in"); }, delay);
            io.unobserve(el);
          }
        });
      },
      { rootMargin: "0px 0px -60px 0px", threshold: 0.1 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Stat counters ----------------------------------------------------- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute("data-vl-count"));
    var decimals = parseInt(el.getAttribute("data-vl-decimals") || "0", 10);
    var suffix = el.getAttribute("data-vl-suffix") || "";
    var duration = 1500;
    var start = null;

    function frame(t) {
      if (start === null) start = t;
      var progress = Math.min((t - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = (target * eased).toFixed(decimals) + suffix;
      if (progress < 1) window.requestAnimationFrame(frame);
      else el.textContent = target.toFixed(decimals) + suffix;
    }
    window.requestAnimationFrame(frame);
  }

  function initCounters() {
    var nums = document.querySelectorAll("[data-vl-count]");
    if (!nums.length) return;
    if (reduceMotion || !("IntersectionObserver" in window)) {
      nums.forEach(function (el) {
        var target = parseFloat(el.getAttribute("data-vl-count"));
        var decimals = parseInt(el.getAttribute("data-vl-decimals") || "0", 10);
        el.textContent = target.toFixed(decimals) + (el.getAttribute("data-vl-suffix") || "");
      });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    nums.forEach(function (el) { io.observe(el); });
  }

  /* ---- Newsletter (demo, no submit) -------------------------------------- */
  function initNewsletter() {
    var forms = document.querySelectorAll(".vl-news__form");
    forms.forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        var btn = form.querySelector(".vl-news__btn");
        if (!btn) return;
        btn.textContent = "✓ Subscribed!";
      });
    });
  }

  function init() {
    initAgeGate();
    initReveal();
    initCounters();
    initNewsletter();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
